export default "__VITE_ASSET__Kw4cP7K1__"